/* eslint-disable max-classes-per-file */

import Base, { ErrorBase } from 'requests/objects/_base'
import OrderQuoteService from 'requests/objects/order-quote-service'

/**
 * Order Object
 */
export default class OrderQuotePricing extends Base {
    /**
     * @param {object} data data
     * @param {number=} data.orderQuotePricingId orderQuotePricingId
     * @param {object=} data.orderQuoteService orderQuoteService
     * @param {number=} data.orderQuoteServiceId orderQuoteServiceId
     * @param {string=} data.serviceName serviceName
     * @param {number=} data.quantity quantity
     * @param {number=} data.vat vat
     * @param {number=} data.costExcludingVat costExcludingVat
     */
    constructor({
        orderQuotePricingId = 0,
        orderQuoteService = null,
        orderQuoteServiceId = 0,
        serviceName = '',
        quantity = 0,
        vat = 0,
        costExcludingVat = 0,
        ...data
    } = {}) {
        super(data)
        this.orderQuotePricingId = orderQuotePricingId
        this.orderQuoteService = orderQuoteService ? new OrderQuoteService(orderQuoteService) : null
        this.orderQuoteServiceId = orderQuoteServiceId
        this.serviceName = serviceName
        this.quantity = quantity
        this.vat = vat
        this.costExcludingVat = costExcludingVat && !Number.isNaN(+costExcludingVat) ? +costExcludingVat : null
    }
}

/**
 * User Object used to bind error message
 */
export class ErrorOrderPricing extends ErrorBase {
    constructor() {
        super()
        this.orderQuotePricingId = ''
        this.orderQuoteServiceId = ''
        this.serviceName = ''
        this.quantity = ''
        this.costExcludingVat = ''
    }
}
